module.exports = __webpack_public_path__ + "static/media/bank_300_02.ee1a8221.png";